import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import Content from './Content';

const WhatIfClientTemplate = () => {
  const {
    isInitializing,
    pageContentLoadingError,
  } = usePageContentContext();

  return (
    <DataContainer
      component={Content}
      loading={isInitializing}
      loadingError={pageContentLoadingError}
    />
  );
};

export default WhatIfClientTemplate;
